import { z } from "zod";

export type SurveyValue = boolean | string | string[];

// Question type enum schema
export const QuestionTypeSchema = z.enum([
  "SHORT_TEXT",
  "LONG_TEXT",
  "YES_NO",
  "MULTIPLE_CHOICE",
  "MULTIPLE_CHOICE_MULTI",
]);

// Question definition schema
export const QuestionDefinitionSchema = z
  .object({
    id: z.string().uuid(),
    label: z.string().min(1, "Question label is required"),
    description: z.string(),
    type: QuestionTypeSchema,
    required: z.boolean(),
    options: z
      .array(z.string().min(1, "Option cannot be empty"))
      .nullable()
      .optional(),
  })
  .refine(
    (data) => {
      // Multiple choice questions must have at least 2 options
      if (
        (data.type === "MULTIPLE_CHOICE" ||
          data.type === "MULTIPLE_CHOICE_MULTI") &&
        (!data.options || data.options.length < 2)
      ) {
        return false;
      }
      return true;
    },
    {
      message: "Multiple choice questions must have at least two options",
      path: ["options"],
    },
  );

// Survey definition schema
export const SurveyDefinitionSchema = z.object({
  version: z.string(),
  questions: z
    .array(QuestionDefinitionSchema)
    .min(1, "Survey must have at least one question"),
});

// Survey content schema (for parsing JSON content)
export const SurveyContentSchema = z.object({
  version: z.string(),
  questions: z
    .array(QuestionDefinitionSchema)
    .min(1, "Survey must have at least one question"),
});

// Type exports
export type QuestionType = z.infer<typeof QuestionTypeSchema>;
export type QuestionDefinition = z.infer<typeof QuestionDefinitionSchema>;
export type SurveyDefinition = z.infer<typeof SurveyDefinitionSchema>;
export type SurveyContent = z.infer<typeof SurveyContentSchema>;
